import { usePermissions, useTranslate } from "ra-core";
import { Suspense } from "react";
import { NavLink, Outlet } from "react-router";
import { cn } from "@/lib/utils";
import { SesSandboxBanner } from "./SesSandboxBanner";
import { EmailAttentionBanner } from "./attention/EmailAttentionBanner"; // GAVION A12

const TABS = [
  {
    path: "campagnes",
    label: "gavion.email.common.tabs.campaigns",
    admin: true,
  },
  {
    path: "sequences",
    label: "gavion.email.common.tabs.sequences",
    admin: false,
  },
  // GAVION rep-missed-call: reps see the tab (the « Appel manqué » templates only)
  {
    path: "modeles",
    label: "gavion.email.common.tabs.templates",
    admin: false,
  },
  { path: "segments", label: "gavion.email.common.tabs.segments", admin: true },
  {
    path: "demandes-arret",
    label: "gavion.email.delivery.stop_requests.nav",
    admin: true,
  },
  // GAVION A12: sends on hold or to check
  { path: "a-verifier", label: "gavion.email.attention.nav", admin: true },
] as const;

/** Layout for /courriels/*: title, sandbox banner (admins), section tabs, then the page. */
export const EmailShell = () => {
  const translate = useTranslate();
  const { permissions, isPending } = usePermissions();
  if (isPending) return null;
  const isAdmin = permissions === "admin";
  return (
    // No own width cap: <main> sets it per route (layout/pageWidth.ts: lists wide, editors 1440 px).
    <div className="mx-auto w-full space-y-4 p-4 md:p-6">
      <h1 className="text-2xl font-semibold">
        {translate("gavion.email.common.nav")}
      </h1>
      {isAdmin && <SesSandboxBanner />}
      {isAdmin && <EmailAttentionBanner />}
      <nav
        aria-label={translate("gavion.email.common.nav")}
        className="-mx-4 overflow-x-auto px-4 md:mx-0 md:px-0"
      >
        <ul className="flex min-w-max gap-1 border-b border-border">
          {TABS.filter((t) => isAdmin || !t.admin).map((t) => (
            <li key={t.path}>
              <NavLink
                to={`/courriels/${t.path}`}
                className={({ isActive }) =>
                  cn(
                    "-mb-px inline-flex min-h-11 items-center border-b-2 px-3 text-sm",
                    isActive
                      ? "border-[#F77119] font-medium text-foreground"
                      : "border-transparent text-muted-foreground hover:text-foreground",
                  )
                }
              >
                {translate(t.label)}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      {/* Pages are lazy chunks (emailRoutes): keep the title and tabs while one loads. */}
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </div>
  );
};
